

























import { Vue, Prop, Component } from "vue-property-decorator";
import { FamousItem as IFamousItem } from "@/views/famous/interface";

@Component
export default class FamousItem extends Vue {
  @Prop() data!: IFamousItem;
}
